/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';

import { AppRoles } from 'src/app/app-roles';
import { AuthLevel } from '../domain/enums/authorization-levels.enum';
import CognitoService from '../services/cognito';
import { AppInitializationService } from '../services/app-initialization.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private app: AppRoles,
    private authService: CognitoService,
    private appInitService: AppInitializationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (state.url.startsWith('/auth/')) {
      return true;
    }

    if (!this.appInitService.isAppInitialized()) {
      this.router.navigateByUrl('/auth/login');
      return false;
    }

    const sessionUser = this.appInitService.getSessionUser();

    if (!sessionUser) {
      this.router.navigateByUrl('/auth/login');
      return false;
    }

    const authorization = this.app.isUserAuthorized(sessionUser);

    if (authorization === AuthLevel.UndefinedAuth) {
      this.authService.globalSignOut();
      this.router.navigateByUrl('/auth/login');
      return false;
    }
    return authorization === AuthLevel.Authorized || authorization === AuthLevel.Unauthorized;
  }
}
